import { render, staticRenderFns } from "./auction.vue?vue&type=template&id=78aaa462&scoped=true"
import script from "./auction.vue?vue&type=script&lang=js"
export * from "./auction.vue?vue&type=script&lang=js"
import style0 from "./auction.vue?vue&type=style&index=0&id=78aaa462&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78aaa462",
  null
  
)

export default component.exports